import axios from "axios";
import { Notificar } from "../componentes/Comunes/Notificador";
import Autenticador from "./Autenticador";
import servicioToken from "./servicioToken";

let funcionRefrescarToken: Promise<any> | null = null;

axios.interceptors.request.use(async (req) => {
  let accessToken = servicioToken.obtenerAccessToken();

  if (servicioToken.estaExpiradoElAccessToken()) {
    if (!funcionRefrescarToken) {
      funcionRefrescarToken = Autenticador.obtengaTokenPorRefrescamiento();
    }

    accessToken = await funcionRefrescarToken;
    funcionRefrescarToken = null;
  }

  req.headers = {
    "Content-Type": "application/json",
    Accept: "application/json",
    Authorization: `Bearer ${accessToken}`,
  };

  return req;
});

axios.interceptors.response.use(undefined, async (error) => {
  if (error.response?.status === 401) {
    window.location.href = "/cic_externo/Error/NoAutorizado";
  }

  if (error.response?.status === 403) {
    window.location.href = "/cic_externo/Error/AccesoDenegadoSistema";
    Autenticador.cerrarSesionAccesoDenegado();
  }

  if (error.response?.status === 429) {
    Notificar("error", error.response.data);
  }

  const errorEsperado =
    error.response &&
    error.response.status >= 400 &&
    error.response.status < 500;

  if (!errorEsperado) {
    console.log("Log del error", error);
    Notificar("error", "Ocurrió un error inesperado.");
  }

  return Promise.reject(error);
});

const Http = {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  delete: axios.delete,
};

export default Http;
